var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.543 21.4013C7.28304 21.6423 7.17879 21.9992 7.2703 22.3349C7.36182 22.6705 7.63486 22.9327 7.98449 23.0205C8.33412 23.1084 8.70592 23.0083 8.957 22.7587L11.737 20.0899C11.8086 20.0214 11.8301 19.9182 11.7916 19.8285C11.7531 19.7388 11.6621 19.6802 11.561 19.68H9.439C9.37295 19.6799 9.3096 19.7052 9.263 19.7501L7.543 21.4013Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.543 22.7587C15.9354 23.1225 16.5591 23.1173 16.9448 22.747C17.3306 22.3767 17.336 21.778 16.957 21.4013L15.237 19.7501C15.1904 19.7052 15.127 19.6799 15.061 19.68H12.939C12.8379 19.6802 12.7469 19.7388 12.7084 19.8285C12.6699 19.9182 12.6914 20.0214 12.763 20.0899L15.543 22.7587Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 13.1453C20.7498 12.8369 20.5952 12.5473 20.3345 12.3671C20.0738 12.1868 19.7388 12.1377 19.434 12.2352L18.079 12.6691C18.0028 12.6935 17.919 12.6812 17.8539 12.6362C17.7887 12.5911 17.7501 12.5187 17.75 12.4416V11.52C17.75 10.9898 17.3023 10.56 16.75 10.56H7.75C7.19772 10.56 6.75 10.9898 6.75 11.52V17.28C6.75 17.8102 7.19772 18.24 7.75 18.24H16.75C17.3023 18.24 17.75 17.8102 17.75 17.28V16.3584C17.7501 16.2813 17.7887 16.2089 17.8539 16.1638C17.919 16.1188 18.0028 16.1065 18.079 16.1309L19.433 16.5648C19.7379 16.6626 20.0733 16.6138 20.3342 16.4335C20.5951 16.2531 20.7499 15.9634 20.75 15.6547V13.1453Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 9.6C11.0114 9.6 13.25 7.45097 13.25 4.8C13.25 2.14903 11.0114 0 8.25 0C5.48858 0 3.25 2.14903 3.25 4.8C3.25 7.45097 5.48858 9.6 8.25 9.6Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 9.6C19.4069 9.6 20.75 8.31058 20.75 6.72C20.75 5.12942 19.4069 3.84 17.75 3.84C16.0931 3.84 14.75 5.12942 14.75 6.72C14.75 8.31058 16.0931 9.6 17.75 9.6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.db2c40c9.svg";
export { ForwardRef as ReactComponent };